import config from './config';

const ADSENSE_SCRIPT_SRC = 'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js';

let scriptPromise = null;

export const isAdsenseEnabled = () => {
    if (typeof window === 'undefined') return false;
    if (!config.adsense || config.adsense.enabled !== true) return false;
    if (!config.adsense.client) return false;
    return window.__isProdHost === true;
};

export const loadAdsenseScript = () => {
    if (!isAdsenseEnabled()) return Promise.resolve(false);
    if (scriptPromise) return scriptPromise;

    scriptPromise = new Promise((resolve) => {
        const existing = document.querySelector(
            `script[src^="${ADSENSE_SCRIPT_SRC}"]`,
        );
        if (existing) {
            resolve(true);
            return;
        }

        const script = document.createElement('script');
        script.async = true;
        script.crossOrigin = 'anonymous';
        script.src = `${ADSENSE_SCRIPT_SRC}?client=${encodeURIComponent(config.adsense.client)}`;
        script.onload = () => resolve(true);
        script.onerror = () => {
            scriptPromise = null;
            resolve(false);
        };
        document.head.appendChild(script);
    });

    return scriptPromise;
};

export const getAdsenseClient = () => config.adsense?.client || '';

export const getAdsenseSlot = (key) => config.adsense?.slots?.[key] || '';
